import 'whatwg-fetch';
import { app_dev, app_key_val, app_env, middle_dev, middle_env, middle_key_val } from 'config';
import { couponsWeb_controller } from 'config';

const authHeader = new Headers();
authHeader.append('Accept', 'application/json');
authHeader.append('Content-Type', 'application/json');

export default class LoginService{
    static authPreRecovery(payload = {}) {
        /*
        *   @preAccessKey
        *   Genera un token para solicitar envio de codigo
        *   
        *   IN      |   token (recptch) |   string
        *   IN      |   email           |   string
        *   OUT     |   data[payload]   |   string
        */
        authHeader.set('X-API-KEY', app_key_val);
        return fetch(`${app_dev}/${app_env}/users/preAccessKey`, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: authHeader, 
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(payload)
            }
        ).then((data) => {
            return data.json()
        })
    }
    static authToken(payload = {}, authType = 'register') {
        /*
        *   @sendCode|postAccessKey
        *   Envía código de verificación a correo del cliente
        *   
        *   IN      |   user           |   string
        *   OUT     |   data            |   object
        */
        authHeader.set('X-API-KEY', app_key_val);
        return fetch(`${app_dev}/${app_env}/users/${authType=='register'?'sendCode':'postAccessKey'}`, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: authHeader, 
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(payload)
            }
        ).then((data) => {
            return data.json()
        })
    }
    static authEncrypter(payload = {}) {
        /*
        *   @encripter
        *   Encripta la contraseña del cliente a un formato reconocido por vtex
        *   
        *   IN      |   password        |   string
        *   OUT     |   data[payload]   |   object
        */
        authHeader.set('X-API-KEY', app_key_val);
        return fetch(`${app_dev}/${app_env}/users/encripter`, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: authHeader, 
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(payload)
            }
        ).then((data) => {
            return data.json()
        })
    }
    static authLogin(payload = {}) {
        /*
        *   @login
        *   Verifica los accesos del cliente en vtex
        *   
        *   IN      |   userName        |   string
        *   IN      |   password        |   string
        *   OUT     |   data[payload]   |   object
        */
        authHeader.set('X-API-KEY', app_key_val);
        return fetch(`${app_dev}/${app_env}/users/login`, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: authHeader, 
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(payload)
            }
        ).then((data) => {
            return data.json()
        })
    }
    static authPreRegister(payload = {}) {
        /*
        *   @preRegister
        *   Pre Guarda la informacion del usuario
        *   
        *   IN      |   token (recptch) |   string
        *   IN      |   email           |   string
        *   IN      |   password        |   string
        *   IN      |   firstName       |   string
        *   IN      |   lastName        |   string
        *   OUT     |   data[payload]   |   string
        */
        authHeader.set('X-API-KEY', app_key_val);
        return fetch(`${app_dev}/${app_env}/users/preRegister`, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: authHeader, 
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(payload)
            }
        ).then((data) => {
            return data.json()
        })
    }
    static authConfirmRegister(payload = {}) {
        /*
        *   @register
        *   Verifica los accesos del cliente en vtex
        *   
        *   IN      |   token (vtex)    |   numeric
        *   IN      |   user            |   string
        *   OUT     |   data[payload]   |   object
        * Object Json Response de confirmRegisyter:
        * internalCode { };
	    * message { };
	    * payload{
        *   tokenJwt:''
        * };
        */
        authHeader.set('X-API-KEY', app_key_val);
        return fetch(`${app_dev}/${app_env}/users/confirmRegister`, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: authHeader, 
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(payload)
            }
        ).then((data) => {
            return data.json()
        })
    }
    static authResetPass(payload = {}) {
        /*
        *   @reset?
        *   Cambia la contraseña en la cuenta del cliente vtex
        *   
        *   IN      |   token (vtex)    |   numeric
        *   IN      |   email           |   string
        *   IN      |   password        |   string
        *   OUT     |   data[payload]   |   object
        */
        authHeader.set('X-API-KEY', app_key_val);
        return fetch(`${app_dev}/${app_env}/users/new_password`, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: authHeader, 
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(payload)
            }
        ).then((data) => {
            return data.json()
        })
    }
    static authTokenCoupons(payload = {}) {
        /*
        *   @tokenJWTApplication
        *   Obtiene el token de la aplicación de cupones
        *   
        *   IN      |   jwt (vtex)      |   string
        *   OUT     |   data[payload]   |   object
        */
       
        authHeader.set('X-API-KEY', middle_key_val);
        return fetch(`${middle_dev}/${couponsWeb_controller}/loginApp?ambito=${middle_env}`, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: authHeader, 
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(payload)
            }
        ).then((data) => {
            return data.json()
        })
    }
    static updateUserValidation(payload = {}) {
        /*
        *   @tokenJWTApplication
        *   Obtiene el token de la aplicación de cupones
        *   
        *   IN      |   jwt (vtex)      |   string
        *   OUT     |   data[payload]   |   object
        */
        authHeader.set('X-API-KEY', middle_key_val);
        return fetch(`${middle_dev}/${couponsWeb_controller}/updateUser?ambito=${middle_env}`, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: authHeader, 
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(payload)
            }
        ).then((data) => {
            return data.json()
        })
    }
    static authWithSocial(socialApp = '', payload = {}) {
        /*
        *   @authWithSocial
        *   Recibe el token de autorización de redes sociales
        *   
        *   IN      |   token (social)  |   string
        *   OUT     |   data[payload]   |   object
        */
       const socialScope = {
           facebook: 'loginFacebook', 
           google: 'loginGoogle'
       };
        authHeader.set('X-API-KEY', middle_key_val);
        return fetch(`${middle_dev}/${couponsWeb_controller}/${socialScope[socialApp]}?ambito=${middle_env}`, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: authHeader, 
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(payload)
            }
        ).then((data) => {
            return data.json()
        })
    }

    static crearUsuarioLog(payload = {}) {
        /*
        *   @tokenJWTApplication
        *   Crea el registro usuario Log
        *   
        *    IN     |   jwt (vtex)      |   string
        *    IN     |   internalCode:   |   string
        *    IN     |   jwt             |   string
        *    IN     |   correo          |   string
        *    IN     |   ipPublic        |   string
        *    IN     |   tipoEvento      |   string
        *    IN     |   descripcion     |   string
        *    IN     | timeSessionSeconds|     INT
        *    IN     |    socialScope    |    string
        *    OUT    |   payload{ usuarioLogStatus: "UserLog Created Successful"}  |   string
        */
       
        authHeader.set('X-API-KEY', middle_key_val);
        return fetch(`${middle_dev}/${couponsWeb_controller}/usuarioLog?ambito=${middle_env}`, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: authHeader, 
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(payload)
            }
        ).then((data) => {
            return data.json()
        })
    }


    static ipifyIpPublic() {
        
        return  fetch('https://api.ipify.org?format=jsonp?callback=?', {
            method:'GET',
            headers: {},
        })
        .then(res => {
           return  res.text();
        }).then(ip => {
            return ip;
        });
    
    }
    
}